export default __webpack_public_path__ + "4aacc7014694949b33de0e36e3321e86.png";